import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosPresupuesto, { RESOURCE_PRESUPUESTO } from '@/auth/permissions/modules/presupuesto'

const { mantenimiento, configuracion, transacciones } = permisosPresupuesto

export default [
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/presupuesto/mantenimiento/bandeja-plantillas',
        name: namesMantenimiento.ROUTE_BANDEJA,
        component: () => import('@pages/presupuesto/mantenimiento/BandejaPlantillasPresupuesto.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.bandeja_plantillas',
            resource: RESOURCE_PRESUPUESTO,
            action: mantenimiento.bandejaPlantillas,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.mantenimiento',
                'presupuesto.subopciones.bandeja_plantillas'
            ),
        },
    },
    {
        path: '/presupuesto/mantenimiento/plantilla-presupuesto/:id?',
        name: namesMantenimiento.ROUTE_PLANTILLA_PRESUPUESTO,
        component: () => import('@pages/presupuesto/mantenimiento/PlantillaPresupuesto.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.ver_plantilla',
            resource: RESOURCE_PRESUPUESTO,
            action: mantenimiento.plantillaPresupuesto,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.mantenimiento',
                'presupuesto.subopciones.ver_plantilla'
            ),
        },
    },

    /**
     * RUTAS DE CONFIGURACIÓN
     */
    {
        path: '/presupuesto/configuracion/bandeja-premisas',
        name: namesConfiguracion.ROUTE_BANDEJA_PREMISAS,
        component: () => import('@pages/presupuesto/configuracion/BandejaPremisa.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.bandeja_premisas',
            resource: RESOURCE_PRESUPUESTO,
            action: configuracion.bandejaPremisas,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.configuracion',
                'presupuesto.subopciones.bandeja_premisas'
            ),
        },
    },
    {
        path: '/presupuesto/configuracion/niveles-aprobacion',
        name: namesConfiguracion.ROUTE_BANDEJA_NIVEL_APROBACION,
        component: () => import('@pages/presupuesto/configuracion/PageNivelesAprobacion.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.niveles_aprobacion',
            resource: RESOURCE_PRESUPUESTO,
            action: configuracion.bandejaPremisas,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.configuracion',
                'presupuesto.subopciones.niveles_aprobacion'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/presupuesto/transacciones/bandeja-presupuesto',
        name: namesTransacciones.ROUTE_BANDEJA_PRESUPUESTO,
        component: () => import('@pages/presupuesto/transacciones/BandejaPresupuesto.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.bandeja_presupuesto',
            resource: RESOURCE_PRESUPUESTO,
            action: transacciones.bandejaPresupuesto,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.transacciones',
                'presupuesto.subopciones.bandeja_presupuesto'
            ),
        },
    },
    {
        path: '/presupuesto/transacciones/presupuesto/:id',
        name: namesTransacciones.ROUTE_EDITAR_PRESUPUESTO,
        component: () => import('@pages/presupuesto/transacciones/CrearPresupuesto.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.presupuesto',
            resource: RESOURCE_PRESUPUESTO,
            action: transacciones.crearPresupuesto,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.transacciones',
                'presupuesto.subopciones.presupuesto'
            ),
        },
    },
    {
        path: '/presupuesto/transacciones/aprobar-presupuesto',
        name: namesTransacciones.ROUTE_APROBAR_PRESUPUESTO,
        component: () => import('@pages/presupuesto/transacciones/AprobarPresupuesto.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.aprobar_presupuesto',
            resource: RESOURCE_PRESUPUESTO,
            action: transacciones.aprobacionPresupuesto,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.transacciones',
                'presupuesto.subopciones.aprobar_presupuesto'
            ),
        },
    },
    {
        path: '/presupuesto/transacciones/alcance-presupuesto/:id?',
        name: namesTransacciones.ROUTE_ALCANCE_PRESUPUESTO,
        component: () => import('@pages/presupuesto/transacciones/AlcancePresupuesto.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.alcance_presupuesto',
            resource: RESOURCE_PRESUPUESTO,
            action: transacciones.alcancePresupuesto,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.transacciones',
                'presupuesto.subopciones.alcance_presupuesto'
            ),
        },
    },
    {
        path: '/presupuesto/transacciones/bandeja-solicitudes-alcance',
        name: namesTransacciones.ROUTE_BANDEJA_SOLICITUD_ALCANCE,
        component: () => import('@pages/presupuesto/transacciones/BandejaSolicitudesAlcance.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.bandeja_solicitudes_alcance',
            resource: RESOURCE_PRESUPUESTO,
            action: transacciones.bandejaSolicitudAlcance,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.transacciones',
                'presupuesto.subopciones.bandeja_solicitudes_alcance'
            ),
        },
    },
    {
        path: '/presupuesto/transacciones/aprobacion-alcance-presupuesto',
        name: namesTransacciones.ROUTE_APROBACION_ALCANCE_PRESUPUESTO,
        component: () => import('@pages/presupuesto/transacciones/AprobacionAlcancePresupuesto.vue'),
        meta: {
            title: 'i18n:presupuesto.subopciones.aprobacion_alcance_presupuesto',
            resource: RESOURCE_PRESUPUESTO,
            action: transacciones.aprobacionAlcancePresupuesto,
            breadcrumb: buildBreadcrumb(
                'a:presupuesto.menu_title',
                'a:global.menu.transacciones',
                'presupuesto.subopciones.aprobacion_alcance_presupuesto'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
] as RouteConfig[]
